module.exports = __webpack_public_path__ + "img/2213f86.jpg";